module.exports = __webpack_public_path__ + "img/xiaosanjia1.6d287d63.png";